var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"block"},[_c('video',{staticClass:"block__video",attrs:{"src":_vm.block.file && _vm.block.file.url,"oncontextmenu":"return false;","controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }